import { GzTimeRangeSliderWebComponent } from './component/GzTimeRangeSliderWebComponent';

export { GzTimeRangeSliderWebComponent };
